import { render, staticRenderFns } from "./google-2fa.vue?vue&type=template&id=41ca6157&scoped=true"
import script from "./google-2fa.vue?vue&type=script&lang=js"
export * from "./google-2fa.vue?vue&type=script&lang=js"
import style0 from "./google-2fa.vue?vue&type=style&index=0&id=41ca6157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ca6157",
  null
  
)

export default component.exports